export function partition<T>(items: T[], condition: (item: T) => boolean): [T[], T[]] {
    return items.reduce(
        (acc, item) => {
            if (condition(item)) {
                acc[0].push(item);
            } else {
                acc[1].push(item);
            }
            return acc;
        },
        [[], []] as [T[], T[]],
    );
}
